<div class="element-type-ordering">
<div *ngIf="element.showDefaultText" class="question-block-label mb-3" style="text-align: center; font-size:0.8em;margin-bottom: 4em;">
  <!-- <tra-md slug="txt_default_order_instr"></tra-md> -->
  <tra-md [slug]="getDefaultOrderInstrSlug()"></tra-md>

</div>

<p
  *ngIf="!isLocked"
  class="sr-only"
  [id]="getInstructionsId()"
>{{ getKeyboardInstructions() }}</p>

<p class="sr-only" aria-live="polite" aria-atomic="true" data-ui-name="Live Message" data-ui-component="element-render-order" data-testid="element-render-order-live-message">{{ liveMessage }}</p>

<div cdkDropListGroup
    [style.display]="'flex'"
    [style.flex-direction]="isVertical() ? (element?.isTargetOrientationReversed ? 'row-reverse' : 'row') : (element?.isTargetOrientationReversed ? 'column-reverse' : 'column')"
    [style.margin-left.em]="isVertical() && isTargetMode()? 4 : 0"
>
  <div 
    class="option-container"
    cdkDropList 
    [cdkDropListDisabled]="isLocked"
    (cdkDropListDropped)="(!isTargetMode()) ? drop(options, $event) : dropTargetMode($event, null, true)"
    [attr.tabindex]="!isLocked && isReturnDestinationActive() ? 0 : null"
    (keyup.Enter)="(isTargetMode()) ? onEnterdropTargetMode($event, options, null, null, true) : ''; "
    (keydown.space)="$event.preventDefault()"
    (keyup.space)="(isTargetMode()) ? onEnterdropTargetMode($event, options, null, null, true) : ''; "
    (click)="onAssistiveTechnologyTargetClick($event, options, null, null, true)"
    (mousedown)="(isTargetMode()) ? onClickToDropTargetMode($event, options, null, null, true) : ''; "
    [attr.role]="!isLocked && isReturnDestinationActive() ? 'button' : 'group'"
    [attr.aria-label]="getSourceAccessibleLabel()"
    [attr.aria-keyshortcuts]="!isLocked && isReturnDestinationActive() ? 'Enter Space' : null"
    [attr.aria-disabled]="isLocked ? 'true' : null"
    [attr.aria-describedby]="!isLocked ? getInstructionsId() : null"
    [cdkDropListSortingDisabled]="isTargetMode()"
    [cdkDropListData]="this.options"
    [cdkDropListOrientation]="isHorizontal() ? 'horizontal' : 'vertical'"
    [class.is-vertical]="isVertical()"
    [class.is-horizontal]="isHorizontal()"
    [class.is-target-mode-source]="isTargetMode()"
    [ngStyle]="getDragWidthSet()"
   data-ui-name="Div" data-ui-component="element-render-order" data-testid="element-render-order-div">
    <div cdkDrag [cdkDragDisabled]="isLocked"
      *ngFor="let optionElement of options; let optionIndex = index;" 
      [attr.role]="!isLocked && isReturnDestinationActive() ? null : 'button'"
      [attr.tabindex]="isLocked || isReturnDestinationActive() || optionElement.isReadOnly ? null : 0"
      (keyup.enter)="onEnter($event, optionElement, options, optionIndex); playTargetAudio(optionElement)"
      (keydown.space)="$event.preventDefault()"
      (keyup.space)="onEnter($event, optionElement, options, optionIndex); playTargetAudio(optionElement)"
      (click)="onAssistiveTechnologyOptionClick($event, optionElement, options, optionIndex)"
      (mousedown)="onClickToDrag($event, optionElement, options, optionIndex); playTargetAudio(optionElement)"
      [attr.aria-disabled]="isLocked || optionElement.isReadOnly ? 'true' : null"
      [attr.aria-pressed]="isSelected(optionElement, options)"
      [attr.aria-keyshortcuts]="!isLocked && !optionElement.isReadOnly ? 'Enter Space' : null"
      [attr.aria-describedby]="!isLocked && !optionElement.isReadOnly ? getInstructionsId() : null"
      [class.is-selected]="isSelected(optionElement, options)"
      [class.is-selected-edit]="editSelection.isSelectedEdit(optionElement, questionPubSub)"
      [style.border]="editSelection.getBorder(optionElement, questionPubSub)"
     data-ui-name="Div" data-ui-component="element-render-order" data-testid="element-render-order-div-0874dec">
      <div 
        class="inner-option-container"
        [class.is-vertical]="isVertical()"
        [class.is-horizontal]="isHorizontal()"
        [style.height]="'inherit'"
        [style.max-height]="'inherit'"
        style="display:flex;flex-grow:1;"
        *ngIf="!optionElement?.isReadOnly || !isTargetMode()"
      >
        <div *ngIf="optionIndex !== 0 && !isTargetMode()" style="padding:0.3em; flex-grow:0;">
          <div *ngIf="!element?.delimiterType || element?.delimiterType=='text'" [style.line-height]="'1em'" [innerHTML]="element?.delimiter ? processThisText(element?.delimiter) : ''">
            <!--<markdown-inline [input]="element.delimiter"></markdown-inline>-->
          </div>
          <div *ngIf="element?.delimiterType=='image'">
            <element-render-image *ngIf="element?.delimiterImg" [element]="element?.delimiterImg" data-ui-name="Element render image" data-ui-component="element-render-order" data-testid="element-render-order-element-render-image"></element-render-image>
          </div>
          <div *ngIf="element?.delimiterType=='icon'">
            <i *ngIf="element?.delimiterImg" [class]="element?.delimiterIcon"></i>
          </div>
        </div>
        <div 
          [ngSwitch]="optionElement?.elementType" class="option not-in-target" 
          [style.color]="element?.colourScheme?.textColor ? element?.colourScheme?.textColor : ''"
          [style.backgroundColor]="element?.colourScheme?.backgroundColor ? element?.colourScheme?.backgroundColor : ''"
          [ngStyle]="isTargetMode() ? getDims(false) : {}"
          [style.justify-content]="element?.isCenterDraggableContent ? 'center' : 'left'"
          [style.align-items]="element?.isCenterDraggableContent ? 'center' : 'left'"
        >
        <ng-container *ngSwitchCase="'text'">
          <div *ngIf="isAdvTextEl(optionElement)" >
            <element-render-text [element]="optionElement" data-ui-name="Element render text" data-ui-component="element-render-order" data-testid="element-render-order-element-render-text"></element-render-text>
          </div>

          <render-highlightable
            *ngIf="!isAdvTextEl(optionElement)"
            [inputString]="getText(optionElement)"
            [entryId]="optionElement.entryId"
            [prop]="getTextProp(optionElement)"
            [isDiv]="true"
            [isWholeHighlight]="true"
            [isNotSelectable]="true"
            (click)="highlighter.checkInitWholeHighlight(optionElement.entryId, getTextProp(optionElement), getText(optionElement))"
           data-ui-name="Render highlightable" data-ui-component="element-render-order" data-testid="element-render-order-render-highlightable">
            <div *ngIf="!isAdvTextEl(optionElement)" [style.line-height]="'1em'" [style.text-align]="element?.isCenterDraggableContent ? 'center' : 'left'" style="white-space: pre-wrap;" [innerHTML]="getText(optionElement)"></div>
          </render-highlightable>
            <!--<markdown-inline [input]="optionElement.content"></markdown-inline>-->
        </ng-container>          
          <div *ngSwitchCase="'image'">
            <element-render-image [element]="optionElement" data-ui-name="Element render image" data-ui-component="element-render-order" data-testid="element-render-order-element-render-image-element-render-image"></element-render-image>
          </div>
          <div *ngSwitchCase="'math'">
            <render-math [obj]="optionElement" [prop]="'content'" data-ui-name="Render math" data-ui-component="element-render-order" data-testid="element-render-order-render-math"></render-math>
          </div>
        </div>
      </div>
      <render-audio
        [url]="getElementAudio(optionElement?.voiceover)"
        [trigger]="getAudioTrigger(optionElement)"
        [isTriggerDisabled]="!isVoiceoverEnabled()"
       data-ui-name="Render audio" data-ui-component="element-render-order" data-testid="element-render-order-render-audio"></render-audio>
    </div>
  </div>

  <div *ngIf="isTargetMode()" style="display:flex;align-items:center;" [style.flex-direction]="getTargetFlowDirection()">
    <div *ngIf="!element?.isShowSeparatorInRenderHidden">
      <div *ngIf="element?.separatorType == 'text'">
        <element-render-text *ngIf="element?.separatorText" [element]='element?.separatorText' data-ui-name="Element render text" data-ui-component="element-render-order" data-testid="element-render-order-element-render-text-element-render-text"></element-render-text>
      </div>
      <div *ngIf="this.element?.separatorType == 'image'">
        <element-render-image *ngIf="this.element?.separatorImage" [element]='this.element?.separatorImage' data-ui-name="Element render image" data-ui-component="element-render-order" data-testid="element-render-order-element-render-image-7d014b83"></element-render-image>
      </div>
      <div *ngIf="this.element?.separatorType == 'canvas'">
        <element-render-canvas *ngIf="this.element?.separatorCanvas" [element]='this.element?.separatorCanvas' [changeCounter]="this.element?.separatorCanvas._changeCounter" data-ui-name="Element render canvas" data-ui-component="element-render-order" data-testid="element-render-order-element-render-canvas"></element-render-canvas>
      </div>
    </div>
    <div
      class="option-container"
      [class.is-vertical]="isVertical()"
      [class.is-horizontal]="isHorizontal()"
      [style.margin-right.em]="isVertical() && element?.isTargetOrientationReversed ? 4 : 0"
      [style.margin-left.em]="isVertical() && !element?.isTargetOrientationReversed ? 4 : 0"
      [style.margin-top.em]="isHorizontal() && !element?.isTargetOrientationReversed ? 4 : 0"
      [style.margin-bottom.em]="isHorizontal() && element?.isTargetOrientationReversed ? 4 : 0"
    >
      <div *ngFor="let optionElement of answers; let i = index;">
        <div 
          class="inner-option-container"
          [class.is-vertical]="isVertical()"
          [class.is-horizontal]="isHorizontal()"
          [style.left.em]="this.element?.options[i] && this.element?.options[i].x ? this.element?.options[i].x : 0"
          [style.top.em]="this.element?.options[i] && this.element?.options[i].y ? this.element?.options[i].y : 0"
        >
          <div *ngIf="i !== 0" style="padding:0.3em; flex-grow:0; align-self:center;">
            <div *ngIf="!element?.delimiterType || element?.delimiterType=='text'" [style.line-height]="'1em'" [innerHTML]="element?.delimiter ? processThisText(element?.delimiter) : ''">
              <!--<markdown-inline [input]="element?.delimiter"></markdown-inline>-->
            </div>
            <div *ngIf="element?.delimiterType=='image'">
              <element-render-image *ngIf="element?.delimiterImg" [element]="element?.delimiterImg" data-ui-name="Element render image" data-ui-component="element-render-order" data-testid="element-render-order-element-render-image-context-fd32751d"></element-render-image>
            </div>
            <div *ngIf="element?.delimiterType=='icon'">
              <i *ngIf="element?.delimiterImg" [class]="element?.delimiterIcon"></i>
            </div>
          </div>
          <div
            class="target-container-control"
            style="display:flex; flex-wrap: nowrap;align-items: center;"
            [style.flex-grow]="1"
            [style.flex-direction]="'column'"
            (keyup.Enter)="canBeDropped(optionElement) ? onEnterdropTargetMode($event, optionElement, element?.options[i], i , false) : '';"
            (keydown.space)="$event.preventDefault()"
            (keyup.space)="canBeDropped(optionElement) ? onEnterdropTargetMode($event, optionElement, element?.options[i], i , false) : '';"
            (click)="onAssistiveTechnologyTargetClick($event, optionElement, element?.options[i], i, false)"
            (mousedown)="canBeDropped(optionElement) ? onClickToDropTargetMode($event, optionElement, element?.options[i], i , false) : '';"
            [attr.tabindex]="isLocked || !canBeDropped(optionElement) ? null : 0"
            role="button"
            [attr.aria-label]="getTargetAccessibleLabel(i)"
            [attr.aria-disabled]="isLocked || !canBeDropped(optionElement) ? 'true' : null"
            [attr.aria-pressed]="isSelected(element?.options[i], optionElement)"
            [attr.aria-keyshortcuts]="!isLocked && canBeDropped(optionElement) ? 'Enter Space' : null"
            [attr.aria-describedby]="!isLocked ? getInstructionsId() : null"
           data-ui-name="Div" data-ui-component="element-render-order" data-testid="element-render-order-div-1fbb7cf">
            <div [style.color]="this.element?.colourScheme?.textColor"
                [style.backgroundColor]="this.element?.colourScheme?.backgroundColor"
                [ngStyle]="isTargetMode() ? getDims(true) : {}"
                [style.border-style]="'solid'"
                [style.border-width.em]="0.1"
                [style.border-color]="'#000000'"
                style="display:flex;flex-direction:column;justify-content: flex-start;align-items: center;"
                cdkDropList [cdkDropListDisabled]="isLocked || !canBeDropped(optionElement)" [cdkDropListData]="optionElement" (cdkDropListDropped)="canBeDropped(optionElement) ? dropTargetMode($event, element?.options[i], false) : '';"
                [cdkDropListEnterPredicate]="canBeDroppedPredicate"
               data-ui-name="Div" data-ui-component="element-render-order" data-testid="element-render-order-div-d859d12">
  
              <div (mousedown)="playTargetAudio(this.element?.options[i], dropTriggers, 'label_voiceover')"
              style="display:flex;flex-direction: column;white-space:pre;align-self:stretch" data-ui-name="Div" data-ui-component="element-render-order" data-testid="element-render-order-div-528f043">
                <div [style.text-align]="this.element?.isCenterLabelContent ? 'center' : 'left'"
                    [style.line-height]="'1em'"
                    [style.align-self]="'stretch'"
                    [style.border-bottom]="this.element?.options[i].label && this.element?.options[i].label != '' ? '2px solid' : 'none'"
                    *ngIf="!this.element?.options[i].labelType || this.element?.options[i].labelType=='text' || this.element?.options[i].labelType=='simple_text'"
                    [innerHTML]="this.element?.options[i].label ? processThisText(this.element?.options[i].label) : ''">
                    <!--<markdown-inline [input]="this.element?.options[i].label ? processThisText(this.element?.options[i].label) : ''"></markdown-inline>-->
                </div>
                <div style="display:flex;flex-direction: row;" 
                    [style.justify-content]="this.element?.isCenterLabelContent ? 'center' : 'flex-start'" 
                    [style.border-bottom]="hasDefaultImage(this.element?.options[i].labelImg) ? '2px solid' : 'none'"
                    *ngIf="this.element?.options[i].labelType=='image'" >
                  <element-render-image [style.align-items]="this.element?.isCenterLabelContent ? 'center' : 'left'" [element]="this.element?.options[i].labelImg" data-ui-name="Element render image" data-ui-component="element-render-order" data-testid="element-render-order-element-render-image-context-007bcc48"></element-render-image>
                </div>
                
              </div>


              <div *ngFor="let ans of optionElement" cdkDrag [cdkDragDisabled]="ans.isReadOnly || isLocked" class="option"
                (mousedown)="canBeDropped(optionElement) ? onClickToDropTargetMode($event, optionElement, element?.options[i], i , false) : ''; playTargetAudio(ans)"
                [class.is-selected]="isSelected(element?.options[i], optionElement)"
                [style.margin]="(isSelected(element?.options[i], optionElement)) ? '0.5em': ''"
                [class.is-fixed]="ans.isReadOnly"
                [style.justify-content]="this.element?.isCenterDraggableContent ? 'center' : 'left'"
                [style.align-items]="this.element?.isCenterDraggableContent ? 'center' : 'left'"
                [ngStyle]="isTargetMode() ? getDims(false) : {}"
                [class.is-selected-edit]="editSelection.isSelectedEdit(ans, questionPubSub)"
                [style.border]="editSelection.getBorder(ans, questionPubSub)"
                 data-ui-name="Div" data-ui-component="element-render-order" data-testid="element-render-order-div-11542a5">
                <div [ngSwitch]="ans.elementType">
                  <ng-container *ngSwitchCase="'text'">
                    <div *ngIf="isAdvTextEl(ans)" >
                      <element-render-text [element]="ans" data-ui-name="Element render text" data-ui-component="element-render-order" data-testid="element-render-order-element-render-text-dd192de5"></element-render-text>
                    </div>


                    <render-highlightable
                      *ngIf="!isAdvTextEl(ans)"
                      [inputString]="getText(ans)"
                      [entryId]="ans.entryId"
                      [prop]="getTextProp(ans)"
                      [isDiv]="true"
                      [prop]="'caption'"
                      [isWholeHighlight]="true"
                      [isNotSelectable]="true"
                      (click)="highlighter.checkInitWholeHighlight(ans.entryId, getTextProp(ans), getText(ans))"
                     data-ui-name="Render highlightable" data-ui-component="element-render-order" data-testid="element-render-order-render-highlightable-1bd30e6">
                      <div *ngIf="!isAdvTextEl(ans)" [style.line-height]="'1em'" [style.text-align]="element?.isCenterDraggableContent ? 'center' : 'left'" style="white-space: pre-wrap;" [innerHTML]="getText(ans)"></div>
                    </render-highlightable>
                      <!--<markdown-inline [input]="optionElement.content"></markdown-inline>-->
                  </ng-container>                  
                  <div *ngSwitchCase="'image'">
                    <element-render-image [element]="ans" data-ui-name="Element render image" data-ui-component="element-render-order" data-testid="element-render-order-element-render-image-image-2b061c4c"></element-render-image>
                  </div>
                  <div *ngSwitchCase="'math'">
                    <render-math [obj]="ans" [prop]="'content'" data-ui-name="Render math" data-ui-component="element-render-order" data-testid="element-render-order-render-math-render-math"></render-math>
                  </div>
                </div>
                <render-audio
                  [url]="getElementAudio(ans?.voiceover)"
                  [trigger]="getAudioTrigger(ans)"
                  [isTriggerDisabled]="!isVoiceoverEnabled()"
                 data-ui-name="Render audio" data-ui-component="element-render-order" data-testid="element-render-order-render-audio-render-audio"></render-audio>
              </div>
            </div>
            <render-audio
              [url]="getElementAudio(this.element?.options[i].label_voiceover)"
              [trigger]="getAudioTrigger(this.element?.options[i], dropTriggers)"
              [isTriggerDisabled]="!isVoiceoverEnabled()"
             data-ui-name="Render audio" data-ui-component="element-render-order" data-testid="element-render-order-render-audio-3bb02808"></render-audio>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
